<section class="panel" [class.headerless]="hideHeader">
  @if (!hideHeader) {
    <header class="panel-header">
      <p class="eyebrow">Publishing</p>
      <h3>Release control</h3>
    </header>
  }

  <div class="field-table">
    <label class="field-row">
      <span class="field-label">State</span>
      <select [ngModel]="landingPage.publicationState" (ngModelChange)="updateState($event)">
        @for (state of states; track state) {
          <option [ngValue]="state">{{ state }}</option>
        }
      </select>
    </label>

    <div class="field-row">
      <span class="field-label">Public visibility</span>
      <strong>{{ landingPage.isPubliclyVisible ? 'Visible' : 'Hidden' }}</strong>
    </div>

    @if (landingPage.publicationState === 'Scheduled') {
      <label class="field-row">
        <span class="field-label">Publish at</span>
        <input type="datetime-local" [ngModel]="toLocalValue()" (ngModelChange)="updateScheduledPublishAt($event)" />
      </label>
    }

    <div class="field-row">
      <span class="field-label">Published at</span>
      <strong>{{ landingPage.publishedAt ? (landingPage.publishedAt | date: 'short') : 'Not published' }}</strong>
    </div>

    <div class="field-row">
      <span class="field-label">Updated at</span>
      <strong>{{ landingPage.updatedAt | date: 'short' }}</strong>
    </div>
  </div>
</section>
